import * as React from "react";
import Loader from "../../../components/atoms/Loader";
import KarteItem from "../../../components/features/KarteItem";
import KarteInterface from "../../../interfaces/KarteInterface";
import styles from "./styles.scss";

interface Props {
  kartes: KarteInterface[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
}

const renderKartesItems = (kartes: KarteInterface[]) => {
  return (
    <React.Fragment>
      {renderPinnedKarte(kartes)}
      {renderKartes(kartes)}
    </React.Fragment>
  );
};

const renderPinnedKarte = (kartes: KarteInterface[]) => {
  const karte: KarteInterface | undefined = kartes.find(
    (karte: KarteInterface) => karte.pinned,
  );
  if (!karte) {
    return null;
  }
  return (
    <KarteItem
      key={`StudentKarteList-${karte.id}`}
      section={karte.student.section}
      karte={karte}
      canPin={true}
    />
  );
};

const renderKartes = (kartes: KarteInterface[]) => {
  return kartes.map((karte: KarteInterface) => {
    if (karte.pinned) {
      return null;
    }
    return (
      <KarteItem
        key={`StudentKarteList-${karte.id}`}
        section={karte.student.section}
        karte={karte}
        canPin={true}
      />
    );
  });
};

const StudentKarteList = ({ kartes, isLoading, isFetchingNextPage }: Props) => {
  if (isLoading) {
    return <Loader loading />;
  }

  return (
    <div className={styles.root} aria-label="カルテ一覧" role="list">
      {kartes.length > 0 ? (
        renderKartesItems(kartes)
      ) : (
        <p>カルテがまだありません</p>
      )}
      <Loader loading={isFetchingNextPage} />
    </div>
  );
};

export default StudentKarteList;
